module.exports = __webpack_public_path__ + "img/b825f4845a9b5ef3d3908882b3c3b87.80d0890a.png";